export default __webpack_public_path__ + "static/banner-ai1-cb8893b93fa7d160fccba5d413f80ade.jpg";